import axios from "../../../util/axios";


export default{
    // https://geo.datav.aliyun.com/areas_v3/bound/100000_full.json 这个是标准地址,100000表示中国，其它用标准行政区划
    getGeo: (adCode) => axios.get({url: `/basedata/common/geo/aliyunGeo`, data: {adCode: `${adCode}_full`}}),
}